import Layout from "../layouts/index";
import Login from "../screens/Account/Login";

const LoginPage = () => {
  return (
    <Layout>
      <Login />
    </Layout>
  );
};

export default LoginPage;
